// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1rTvE","content":"RecentSearches_content__34VKf"};